import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const hazardFamilyClimateVariablesRoutes: Routes = [
  {
    title: 'pagesTitles.hazardFamilyClimateVariables',
    path: APP_ROUTES.HAZARD_FAMILY_CLIMATE_VARIABLES,
    canActivate: [permissionGuard(APP_PERMISSIONS.HazardFamilyClimateVariableRead)],
    loadComponent: () =>
      import('./pages/hazard-family-climate-variables').then(
        (m) => m.HazardFamilyClimateVariablesPage
      ),
  },
];
